<template>
  <base-modal v-if="showModal" @modalState="close" class="modal-first-gifts">
    <template v-slot:content>
      <div class="c-first-gifts">
        <h6 class="title">Obaaa! Vocês receberam o primeiro presente! 😍</h6>
        <p>
          Acompanhe todos os presentes que vocês receberem na seção
          <strong>"Presentes recebidos”</strong>.
        </p>
        <img :src="imgGiftsReceived" alt="Notebook com presentes recebidos" />

        <button @click="close" type="button" class="button is-primary">
          Continuar
        </button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import GiftsApi from '@/lib/api/Gifts'
import BaseModal from '@/components/BaseModal.vue'
import imgGiftsReceived from '@/assets/img/gifts/gift-list/notebook-presentes-recebidos.jpg'

export default {
  components: {
    BaseModal,
  },

  data() {
    return {
      showModal: false,
      surveyType: 'lista_modal_presente_recebido',
      imgGiftsReceived,
    }
  },

  computed: {
    ...mapGetters({
      wedId: 'app/getWedId',
      logonToken: 'app/logonToken',
    }),

    hasAlreadyAnswered() {
      return JSON.parse(localStorage.getItem('shownModalFirstGifts')) ?? false
    },
  },

  mounted() {
    this.open()
  },

  methods: {
    async open() {
      if (!this.hasAlreadyAnswered) {
        const shownToday = await this.getSurveyAnswered()
        if (!shownToday) {
          this.showModal = true
        }
      }
    },

    async close() {
      this.showModal = false
      this.saveSurvey()
    },

    getSurveyAnswered() {
      const giftsApi = new GiftsApi(this.logonToken)
      return giftsApi
        .getGiftsUserSurveysByType(this.surveyType)
        .then((surveys) => {
          if (surveys.length) return true
          return false
        })
        .catch(() => false)
    },

    async saveSurvey() {
      const data = {
        tipo: this.surveyType,
        resposta: 'visualizado',
      }
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi.saveGiftsListsSurvey(data).then((response) => {
        if (response.data) localStorage.setItem('shownModalFirstGifts', true)
      })
    },
  },
}
</script>

<style lang="scss">
.modal-first-gifts {
  padding: 0 16px;
  .c-base-modal__wrapper {
    @include position(absolute, 50%, 0, auto, 0, -50%);
    max-width: 600px;
    width: calc(100% - 30px);
    border-radius: 16px;
    overflow: hidden;
    overflow-y: auto;
  }
}

.c-first-gifts {
  padding: 56px 16px 40px;
  color: $neutral;
  @media screen and (min-width: 480px) {
    padding: 56px 40px 40px;
  }

  .title {
    font-size: 22px;
    font-weight: 700;
    line-height: 29px;
    color: $neutral;
  }

  p {
    max-width: 420px;
    margin: 0 auto 24px;
    font-size: 18px;
    line-height: 22px;
  }

  strong {
    color: $neutral;
  }

  img {
    margin-bottom: 24px;
  }
}
</style>
